import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from 'styles/colors';

const Svg = styled.svg`
  height: 24px;
  width: 24px;
  fill: none;
  &:hover circle:first-of-type {
    stroke: ${colors.primary.ocean};
  }
`;

function Select({ className, selected, disabled, palette }) {
  const [fillColor, setFillColor] = useState(colors.primary.ice);
  const [strokeColor, setStrokeColor] = useState(colors.functional.black);
  useEffect(() => {
    setFillColor(
      disabled
        ? colors.primary.ice
        : selected
        ? palette.primary.main
        : colors.primary.ice,
    );
    setStrokeColor(
      disabled
        ? colors.functional.middleGray
        : selected
        ? palette.primary.main
        : colors.functional.black,
    );
  }, [selected, disabled]);
  return (
    <Svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="11.5" stroke={strokeColor} />
      <circle cx="12" cy="12" r="8" fill={fillColor} />
    </Svg>
  );
}

Select.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  palette: PropTypes.object,
};

export { Select };
